<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <portlet :icon="'fad fa-pencil'" :title="'Rapportage opmerking'">
          <div slot="portletBody">
            <div class="note-item">
              <div class="note-info text-center">
                <div class="row">
                  <div class="col text-left">
                    <button
                      v-if="!reportNoteEditing"
                      type="button"
                      class="btn btn-primary"
                      @click="editReportNote"
                    >Wijzigen</button>
                    <button
                      v-if="reportNoteEditing"
                      type="button"
                      class="btn btn-cancel"
                      @click="cancelReportNoteEdit"
                    >Annuleren</button>
                    <button
                      v-if="reportNoteEditing"
                      type="button"
                      class="btn btn-primary save-button"
                      @click="saveReportNote"
                    >Opslaan</button>
                  </div>
                </div>
              </div>
              <div class="note-description" @dblclick="editReportNote" v-if="!reportNoteEditing">
                <p
                  v-if="getCandidate(this.candidateId).reportNote"
                >{{getCandidate(this.candidateId).reportNote}}</p>
                <p v-else>Nog geen rapporatage opmerking ingevoerd.</p>
              </div>
              <div class="note-description" v-if="reportNoteEditing">
                <textarea
                  class="report-note-editor"
                  v-model="reportNote"
                  placeholder="Voer een rapportage opmerking in."
                ></textarea>
              </div>
            </div>
          </div>
        </portlet>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <portlet :icon="'fad fa-pencil'" :title="'Bijzondere afspraken'">
          <div slot="portletBody">
            <div class="note-item">
              <div class="note-info text-center">
                <div class="row">
                  <div class="col text-left">
                    <button
                      v-if="!specialDealEditing"
                      type="button"
                      class="btn btn-primary"
                      @click="editSpecialDeal"
                    >Wijzigen</button>
                    <button
                      v-if="specialDealEditing"
                      type="button"
                      class="btn btn-cancel"
                      @click="cancelSpecialDealEdit"
                    >Annuleren</button>
                    <button
                      v-if="specialDealEditing"
                      type="button"
                      class="btn btn-primary save-button"
                      @click="saveSpecialDeal"
                    >Opslaan</button>
                  </div>
                </div>
              </div>
              <div class="note-description" @dblclick="editSpecialDeal" v-if="!specialDealEditing">
                <p
                  v-if="getCandidate(this.candidateId).specialDeal"
                >{{getCandidate(this.candidateId).specialDeal}}</p>
                <p v-else>Nog geen bijzondere afspraak.</p>
              </div>
              <div class="note-description" v-if="specialDealEditing">
                <textarea
                  class="report-note-editor"
                  v-model="specialDeal"
                  placeholder="Voer een bijzondere afspraak in."
                ></textarea>
              </div>
            </div>
          </div>
        </portlet>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8">
        <portlet :icon="'fad fa-pencil'" :title="'Notities'">
          <div slot="portletBody">
            <div class="note-item" v-for="item in notesList">
              <div class="note-info text-center">
                <div class="row">
                  <div class="col text-left">
                    <i :class="noteIcon(item.type)"></i>
                  </div>
                  <div class="col">
                    <p v-if="item.createdBy">
                      <strong>
                        {{item.createdBy.firstname}}
                        {{item.createdBy.lastname}}
                      </strong>
                    </p>
                  </div>
                  <div class="col text-right">
                    <p>{{item.dateNote}}</p>
                  </div>
                </div>
              </div>
              <div class="note-description">
                <p>{{item.note}}</p>
              </div>
            </div>
          </div>
        </portlet>
      </div>
      <div class="col-xl-4">
        <portlet :icon="'fad fa-pencil'" :title="'Notitie toevoegen'" :footer="true">
          <div slot="portletBody">
            <label for="type-note">Selecteer type</label>
            <v-select
              taggable
              v-model="newNote.type"
              :options="notesTypes"
              class="form-group"
              id="type-note"
            ></v-select>

            <div class="form-group">
              <label for="note-date">Datum</label>
              <datepicker
                name="noteDate"
                :language="nl"
                id="note-date"
                v-model="newNote.dateNote"
                :fullMonthName="true"
                format="dd-MM-yyyy"
                input-class="form-control"
                :calendar-button="true"
                :calendar-button-icon="'far fa-calendar-alt'"
              ></datepicker>
            </div>
            <div class="form-group">
              <label for="new-note">Notitie</label>
              <textarea v-model="newNote.note" class="form-control" id="new-note" rows="8"></textarea>
            </div>
          </div>

          <div slot="portletFooter" class="col-12 text-right">
            <button @click="addNote" type="submit" class="btn btn-secondary">
              <i class="fa fa-plus mr-2"></i> Toevoegen
            </button>
          </div>
        </portlet>
      </div>
    </div>
  </div>
</template>

<script>
import { nl } from "vuejs-datepicker/dist/locale";
import { mapGetters } from "vuex";

export default {
  props: ["candidateId"],
  data() {
    return {
      nl: nl,
      newNote: {
        type: null,
        dateNote: new Date(),
        note: ""
      },
      newNoteCopy: null,
      notesTypes: [
        "E-mail",
        "WhatsApp",
        "SMS",
        "Telefonisch",
        "Verbaal",
        "Overig"
      ],
      notes: [],
      reportNoteEditing: false,
      reportNote: "",
      specialDeal: "",
      specialDealEditing: false
    };
  },
  firestore() {
    return {
      notes: this.$FB
        .collection("candidates")
        .doc(this.candidateId)
        .collection("notes")
    };
  },
  methods: {
    editSpecialDeal() {
      this.specialDealEditing = true;
    },
    cancelSpecialDealEdit() {
      this.specialDeal = this.getCandidate(this.candidateId).specialDeal;
      this.specialDealEditing = false;
    },
    saveSpecialDeal(e) {
      this.$FB
        .collection("candidates")
        .doc(this.candidateId)
        .update({
          specialDeal: this.specialDeal
        })
        .then(() => {
          this.$toasted.global.successRequest({
            message: "Bijzondere afspraak opgeslagen."
          });
          this.specialDealEditing = false;
        });
    },
    editReportNote() {
      this.reportNoteEditing = true;
    },
    cancelReportNoteEdit() {
      this.reportNote = this.getCandidate(this.candidateId).reportNote;
      this.reportNoteEditing = false;
    },
    saveReportNote(e) {
      this.$FB
        .collection("candidates")
        .doc(this.candidateId)
        .update({
          reportNote: this.reportNote
        })
        .then(() => {
          this.$toasted.global.successRequest({
            message: "Rapportage notitie opgeslagen."
          });
          this.reportNoteEditing = false;
        });
    },
    addNote() {
      let self = this;
      let type = this.newNote.type;
      let note = this.newNote.note;
      if (type !== null && type !== "" && note !== null && note !== "") {
        let id = this.candidateId;
        self.$FB
          .collection("candidates")
          .doc(id)
          .collection("notes")
          .add({
            type: type,
            note: note,
            dateNote: moment(this.newNote.dateNote).format("DD-MM-YYYY"),
            createdBy: this.$store.getters.getUserData,
            department: this.$store.getters.getUserData.selectedDepartment,
          })
          .then(() => {
            this.$toasted.global.successRequest({
              message: "Notitie aangemaakt"
            });
            this.newNote = {
              type: null,
              dateNote: new Date(),
              note: null
            };
            this.newNoteCopy = this.newNote;
          });
      } else {
        this.$toasted.global.failedFormRequest();
      }
    },
    noteIcon(icon) {
      switch (icon) {
        case "Intake":
          return "fal fa-comments-alt";
        case "E-mail":
          return "fal fa-envelope";
        case "WhatsApp":
          return "fab fa-whatsapp";
        case "SMS":
          return "fal fa-sms";
        case "Telefonisch":
          return "fal fa-phone";
        case "Verbaal":
          return "fal fa-user-friends";
        default:
          return "fal fa-pencil";
      }
    }
  },
  computed: {
    ...mapGetters("candidates", ["getCandidate"]),
    notesList() {
      return _.orderBy(
        this.notes,
        [object => moment(object.dateNote, "DD-MM-YYYY").format("YYYYMMDD")],
        ["desc"]
      );
    }
  },
  created() {
    this.newNoteCopy = JSON.parse(JSON.stringify(this.newNote));
    let candidate = this.getCandidate(this.candidateId);
    this.reportNote = candidate.reportNote;
    this.specialDeal = candidate.specialDeal;
  },
  watch: {
    newNote: {
      handler: function(newV) {
        this.$emit(
          "unsavedChanges",
          JSON.stringify(newV) !== JSON.stringify(this.newNoteCopy)
        );
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.save-button {
  margin-left: 1rem;
}
.report-note-editor {
  width: 100%;
}
</style>